'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './banking-accounts-edit.routes';

export class BankingAccountsEditComponent {
  /*@ngInject*/
  constructor(dialogs, BankingAccountsService, $stateParams, $state, $location, Auth, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.BankingAccountsService = BankingAccountsService;
    this.Auth = Auth;
    this.bankingAccountId = $stateParams.id;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$location = $location;

    this.accountTypes = ["individual", "company"];

    this.bankingAccount = {
      object: "bank_account",
      country: "US",
      currency: "usd",
      account_holder_type: 'individual',
      metadata: {
        creationUser: Auth.getCurrentUserSync()._id,
        creationDate: new Date()
      }
    };

    if (this.bankingAccountId) {
      this.BankingAccountsService.get({id: this.bankingAccountId}, account => {
        this.bankingAccount = account;
      }, err => {
        console.log('Could not get the banking account from the server.');
      });

    }

    this.submitted = false;
  }

  create(form) {
    var that = this;

    if (!this.bankingAccount.account_holder_name || this.bankingAccount.account_holder_name.trim() == '') {
      this.dialogs.error("Account Holder Name", "You must enter the account holder's name");
      return;
    }

    if (!this.bankingAccountId) {
      if (!this.bankingAccount.routing_number || this.bankingAccount.routing_number.trim() == '') {
        this.dialogs.error("Routing Number", "You must enter a valid routing number");
        return;
      }

      if (!this.bankingAccount.account_number || this.bankingAccount.account_number.trim() == '') {
        this.dialogs.error("Account Number", "You must enter a valid account number");
        return;
      }
    }

    this.locked = true;

    var onSuccess = () => {
      that.submitted = false;
      that.locked = false;

      var actionString = (that.bankingAccountId) ? "changed" : "created";
      var dlg = that.dialogs.notify("Success", "Your banking account has been "+actionString+" successfully.");
      dlg.result.then(() => {
        that.$state.go("banking-accounts-list");
      });
    };

    var onError = err => {
      that.sendFailure = true;
      that.locked = false;
    };

    if (this.bankingAccountId) {
      this.BankingAccountsService.update({id: this.bankingAccountId}, this.bankingAccount, onSuccess, onError);
    } else {
      this.BankingAccountsService.save(this.bankingAccount, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.bankingAccountEdit', [uiRouter])
  .config(routes)
  .component('bankingAccountEdit', {
    template: require('./banking-accounts-edit.html'),
    controller: BankingAccountsEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/banking-accounts/edit/banking-accounts-edit.component.js